import React, { useEffect } from "react";
import "./MeetOurFounder.scss";


const MeetOurFounder = () => {
  useEffect(() => {
    // Store a function on the global window object to pause the YouTube video
    window.pauseYouTubeVideo = () => {
      const iframe = document.querySelector("iframe");
      if (iframe) {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }
    };
  }, []);

  return (
    <section className="meet-founder section-padding">
      <div className="container">
        <div className="meet-founder__header">
          <h2>
            Meet our founder <span className="heading-xl">the_cycledad</span>
          </h2>
        </div>

        <div className="meet-founder__st">
          <div className="video-iframe-wrapper">
            <iframe
              src="https://www.youtube.com/embed/vj6PhzeTvIQ?si=4fFQK9lYzjiqlArM"
              title="YouTube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div className="meet-founder__links">
            <span className="meet-founder__links-ep">Shark Tank India Season 2, Finale Epsiode</span>
          <h3>
            Follow <a href="https://www.instagram.com/accounts/login/?next=%2Fthe_cycledad%2F&source=omni_redirect" target="_blank" rel="noreferrer">Arjit Soni</a> on his journey to
            <span>#MakeCitiesLiveableAgain</span>
          </h3>
        </div>
      </div>
    </section>
  );
};

export default MeetOurFounder;
